module.exports = "**www.globalpdv.com** utiliza cookies propias y de terceros para mejorar la experiencia del usuario.\n"